import React, { useState, useEffect } from "react";
import axios from "axios";
import { useTranslation } from 'react-i18next'
import { toast, ToastContainer } from 'react-toastify'; // Import ToastContainer
import 'react-toastify/dist/ReactToastify.css';
import './archive.css';


const Apputils = () => {

  const { t, i18n } = useTranslation();

  const [files, setFiles] = useState([]);

  const token = localStorage.getItem("token"); // JWT

  // Carica lista file dal backend
  useEffect(() => {
    fetchFiles();
  }, []);

  const fetchFiles = async () => {
    try {
      const res = await axios.get("https://hat.sofhare.com/files/", {
          headers: { Authorization: `Bearer ${token}` },
        });
      setFiles(res.data);
    } catch (err) {
      console.error("Errore caricamento file", err);
    }
  };

  const handleDownload = async (filename) => {
      try {
        const res = await axios.get(
          `https://hat.sofhare.com/files/download/${filename}/`,
          {
            headers: { Authorization: `Bearer ${token}` },
            responseType: "blob", // necessario per file binari
          }
        );

        // crea download browser
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", filename);

        document.body.appendChild(link);
        link.click();
        link.remove();

        window.URL.revokeObjectURL(url);

      } catch (err) {
        console.error("Errore download file", err);
      }
    };

  return (
    <div className="main-wrapper">
      <div className="tools-wrapperS1-arch">
        <h1 className="archivio-title">Area Download</h1>
        <p>Qui puoi scaricare tutti i file disponibili.</p>

        <table className="files-table">
          <thead>
            <tr>
              <th>File</th>
              <th>Tipo</th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            {files.map((f) => (
              <tr key={f.name}>
                <td>{f.name}</td>
                <td>{f.type || "Generico"}</td>
                <td>
                  <button onClick={() => handleDownload(f.name)}>
                    Scarica
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Apputils;